import { createContext, useContext } from 'react';

type PageHeaderHeightContextType = {
  height: number;
  setHeight: (height: number) => void;
};

// Holds the current height of the page header. The "height" value is applied to a buffer element in GlobalPageHeaderContainer.
// "setHeight" is meant to be used primarily by banner components to adjust the height of the page header on display/hide.
// Default height value is applied in GlobalPageHeaderStateProvider.
const PageHeaderHeightContext = createContext<PageHeaderHeightContextType | undefined>(undefined);

export const usePageHeaderHeight = () => {
  const context = useContext(PageHeaderHeightContext);

  return context;
};

export default PageHeaderHeightContext;
